import React from 'react';
import { IconFill, IconProps } from './IconTemplate';

import { ReactComponent as Icon } from '@assets/icons/search.svg';

export default function SearchIcon(props: IconProps) {
  return <IconFill icon={Icon} {...props} />;
}
